module.exports = __webpack_public_path__ + "img/013.7fc376ab.jpg";